// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Utils
import { scaleToGrid } from '../../../../../utils/grid/gridUtils';
import { getThemeIsDarkMode } from '../../../../../user/account/accountModal/interface/themeSettings/themeSelector';

// Components
import ElectronLink from '../../../../../components/electron/ElectronLink';
import PopupEmptyElementListPlaceholder from '../../../../../components/popupPanel/types/empty/PopupEmptyElementListPlaceholder';

// Styles
import './TrashPopupEmptyPlaceholder.scss';

const mapStateToProps = createStructuredSelector({
    isDarkMode: getThemeIsDarkMode,
});

const TrashPopupPersonalEmptyPlaceholder = ({ isDarkMode, hasOlder, gridSize }) => (
    <PopupEmptyElementListPlaceholder
        className="TrashPopupEmptyPlaceholder"
        img={
            <img
                src={isDarkMode ? require('./empty-trash-dark.png') : require('./empty-trash.png')}
                alt="Empty inbox"
                width={scaleToGrid(220, gridSize)}
                height={scaleToGrid(161, gridSize)}
                draggable={false}
            />
        }
        tip="Your trash is empty"
    >
        {hasOlder && (
            <div className="trash-end-of-results">
                <p className="question">Want to recover something that was deleted more than a week ago?</p>
                <p className="cta">
                    Upgrade for three months history&nbsp;&nbsp;
                    <ElectronLink to="/fee-plan/upgrade">Find out more</ElectronLink>
                </p>
            </div>
        )}
    </PopupEmptyElementListPlaceholder>
);

TrashPopupPersonalEmptyPlaceholder.propTypes = {
    isDarkMode: PropTypes.bool,
    hasOlder: PropTypes.bool,
    gridSize: PropTypes.number,
};

export default connect(mapStateToProps)(TrashPopupPersonalEmptyPlaceholder);
